import { h } from 'preact'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './styles.scss'

function Input({
  label,
  inputProps,
  hasError = false,
  errorMessage = '',
  tooltip,
  brandIcon,
  loading = false,
}) {
  const inputClasses = classNames([
    {
      error: hasError,
    },
    'input',
    'input-text',
    'payment-form__field',
    `tenant-overrides-${inputProps?.id}`,
  ])

  return (
    <label
      className={inputClasses}
      data-testid="element-label"
      id={`label-${inputProps?.id}`}
    >
      <span className="label">{label}</span>
      <div className="group">
        <input type="text" {...inputProps} />
        {tooltip || null}
        {(!hasError && brandIcon) || null}
        {loading && (
          <svg id="loader" viewBox="0 0 100 100" className="input__loader">
            <path
              fill="#000"
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            >
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        )}
      </div>
      {hasError && (
        <p className="message" data-testid="error-message">
          <span className="icon xsmall"></span>
          {errorMessage}
        </p>
      )}
    </label>
  )
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  inputProps: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
}

export default Input
